// Enum doc: https://saviyntars.atlassian.net/wiki/spaces/uidesign/pages/5160960038/Automated+Test+Locators

export const testIds = {
  // Consult
  CONSULT_MODAL_MENU_DROPDOWN: 'consult-modal-menu-dropdown',
  CONSULT_MODAL_COMMENT_INPUTFIELD: 'consult-modal-comment-inputfield',
  CONSULT_MODAL_SUBMIT_BUTTON: 'consult-modal-submit-button',
  CONSULT_MODAL_ALERT_BANNER_ERROR: 'consult-modal-alert-banner-error',
  // CertsSidePanel
  SIDEPANEL_ASIDE: 'sidepanel-aside',
  CERTS_SIDEPANEL_CLOSE_BUTTON: 'sidepanel-close-button',
  // Action Buttons
  SINGLE_ACTION_BUTTON: 'certs-action-button-single',
  // Control Tabs
  CONTROL_TABS_TODO: 'control-tabs-to-do',
  CONTROL_TABS_DONE: 'control-tabs-done',
  CONTROL_TABS_CONS: 'control-tabs-consulted',
  CONTROL_TABS_ALL: 'control-tabs-all',
};

export default testIds;
